export function cookieExists(cookieName: string): boolean {
  return document.cookie.split('; ').some((cookie) => cookie.startsWith(`${cookieName}=`));
}
